let videoPlayed = false;

window.videoSliderButtonClick = function videoSliderButtonClick(event) {
	event.preventDefault();

	var parent = this.closest('.video-container');
	var video = parent.querySelector('figure.video > video');
	var thumbnail = parent.querySelector('.thumbnail');
	var videoFigure = parent.querySelector('figure.video');
	var muteButton = parent.querySelector(".mute-button");

	video.style.visibility = 'visible';
	video.style.opacity = 1;
	video.style.display = 'block';
	videoFigure.style.opacity = 1;
	videoFigure.style.display = 'block';
	videoFigure.style.visibility = 'visible';
	thumbnail.style.opacity = 1;
	muteButton.style.display = 'block';

	var isFirstPlay = !video.src || video.src.trim() === '';

	var allVideos = document.querySelectorAll('.slider-container .video-container');

	allVideos.forEach(function(v) {
		var otherVideo = v.querySelector('figure.video > video');
		var otherThumbnail = v.querySelector('.thumbnail');
		var otherFigure = v.querySelector('figure.video');
		var otherMuteButton = v.querySelector('.mute-button');

		if (otherVideo && otherVideo !== video) {
			otherVideo.pause();
			otherVideo.currentTime = 0;
			otherFigure.classList.add('video-paused');
			otherMuteButton.style.display = 'none';
			otherVideo.style.visibility = 'hidden';

			if (otherThumbnail) {
				const currentOp = parseFloat(getComputedStyle(otherThumbnail).opacity);

				if (currentOp < 1) {
					Velocity(otherThumbnail, { opacity: [1, currentOp] }, { duration: 150, display: 'block' });
				}
			}
		}
	});

	if (!video.paused && !video.ended) {
		video.pause();
		video.currentTime = 0;
		videoFigure.classList.add('video-paused');

		if (thumbnail) {
			const url = thumbnail.dataset.thumb;

			if (url && !thumbnail.style.backgroundImage.includes(url)) {
				thumbnail.style.backgroundImage = `url('${url}')`;
			}

			if (parseFloat(getComputedStyle(thumbnail).opacity) < 1) {
				Velocity(thumbnail, { opacity: [1, 0] }, { duration: 150, display: 'block' });
			}
		}
	} else {
		videoPlayed = true;

		if (isFirstPlay) {
			video.src = video.dataset.src;
			video.setAttribute('playsinline', '');
			video.setAttribute('webkit-playsinline', '');
			video.style.display = 'block';
			video.style.visibility = 'visible';
			video.style.opacity = 1;
			video.classList.add('loaded');
		}

		video.currentTime = 0;

		video.play().catch(err => {
			console.warn('Play failed:', err);
		});

		video.style.visibility = 'visible';
		video.style.opacity = 1;
		video.style.display = 'block';

		videoFigure.classList.remove('video-paused');

		if (thumbnail && parseFloat(getComputedStyle(thumbnail).opacity) > 0) {
			Velocity(thumbnail, { opacity: [0, 1] }, { duration: 150, display: 'none' });
		}

		const overlay = document.createElement('div');

		overlay.className = 'video-start-overlay';
		overlay.style.position = 'absolute';
		overlay.style.top = 0;
		overlay.style.left = 0;
		overlay.style.width = '100%';
		overlay.style.height = '100%';
		overlay.style.backgroundColor = '#8ED5F8';
		overlay.style.zIndex = '2';
		overlay.style.pointerEvents = 'none';
		overlay.style.transition = 'opacity 1s ease';
		overlay.style.opacity = '1';

		videoFigure.appendChild(overlay);

		setTimeout(() => {
			overlay.style.opacity = '0';
		}, 500);

		setTimeout(() => {
			if (overlay && overlay.parentNode) {
				overlay.parentNode.removeChild(overlay);
			}
		}, 1050);
	}
};

window.initVideoSlides = function initVideoSlides() {
	var videosInSlider = [].slice.call(document.querySelectorAll('.slider-container .video-container'));

	videosInSlider.forEach(function(video) {
		var overlay = video.querySelector('.thumbnail');
		var mediaPlayer = video.querySelector('video');

		if (!videoPlayed) {
			mediaPlayer.style.display = 'none';
		}

		if (mediaPlayer) {
			mediaPlayer.setAttribute('playsinline', '');
			mediaPlayer.setAttribute('webkit-playsinline', '');
		}

		var audioIcon = video.querySelector('.audio_icon');

		if (audioIcon && mediaPlayer && !audioIcon.dataset.bound) {
			audioIcon.dataset.bound = 'true';

			audioIcon.addEventListener('click', (event) => muteVideo(event, mediaPlayer));
		}

		if (overlay && !overlay.dataset.bound) {
			overlay.dataset.bound = 'true';

			overlay.addEventListener('click', videoSliderButtonClick);
		}
	});
};

window.videoLazyload = function videoLazyload(video) {
	if (
		video.tagName !== 'VIDEO' ||
		!video.dataset.src ||
		video.classList.contains('loaded')
	) return;

	video.src = video.dataset.src;
	video.setAttribute('playsinline', '');
	video.setAttribute('webkit-playsinline', '');
	video.classList.add('loaded');
};

var videoButtonsMlp = [].slice.call(document.querySelectorAll('.slider-container .video-container button'));

videoButtonsMlp.forEach(function(videoButton) {
	videoButton.addEventListener('click', videoSliderButtonClick);
});

function playVideo(video) {
	if (!video.src) {
		video.src = video.dataset.src;
	}

	if (video.tagName === 'VIDEO') {
		video.setAttribute('playsinline', '');
		video.setAttribute('webkit-playsinline', '');
		video.autoplay = true;
		video.play().catch(() => {});
	}
}

function resetVideo(video) {
	var src = video.src;
	video.src = src.replace('?autoplay=1&rel=0', '');
}

function muteVideo(event, video) {
	event.preventDefault();
	event.stopPropagation();

	video.muted = !video.muted;

	if (video.muted) {
		event.target.classList.add('audio_off');
	} else {
		event.target.classList.remove('audio_off');
	}
}

var videosInSlider = [].slice.call(document.querySelectorAll('.slider-container .video-container'));

videosInSlider.forEach(function(video) {

	var muteButton = video.querySelector('.mute-button');
	var mediaPlayer = video.querySelector('video');

	muteButton.style.display = 'none';
	mediaPlayer.style.opacity = 0;

	const slickSlide = video.closest('.slick-slide');
	const slickIndex = slickSlide ? parseInt(slickSlide.getAttribute('data-index'), 10) : -1;

	const isFirstOrSecondSlide = slickIndex === 0 || slickIndex === 1;


	if (isFirstOrSecondSlide) {
		const carouselVideo = video.querySelector('.video .carousel-video');

		if (carouselVideo) {
			carouselVideo.classList.add('loaded');
			carouselVideo.dataset.loaded = 'true';
		}
	}
});

initVideoSlides();

function pauseAllSliderVideos() {
	document.querySelectorAll('.slider-container .video-container').forEach(container => {
		const video = container.querySelector('video');
		const thumbnail = container.querySelector('.thumbnail');
		const figure = container.querySelector('figure.video');
		const muteButton = container.querySelector('.mute-button');

		muteButton.style.display = 'none';
		video.style.visibility = 'hidden';
		figure.style.opacity = 0;

		if (thumbnail.classList.contains('thumbnail-loaded')) {
			thumbnail.style.opacity = 1;
		}

		thumbnail.style.display = 'block';

		if (video && !video.paused) {
			video.pause();
			video.currentTime = 0;
		}

		if (figure) {
			figure.classList.add('video-paused');
		}
	});
}

function bindSlickNavEvents() {
	const navButtons = document.querySelectorAll('.slick-prev, .slick-next');

	navButtons.forEach(button => {
		if (!button.dataset.videoBound) {
			button.addEventListener('click', pauseAllSliderVideos);
			button.dataset.videoBound = 'true';
		}
	});
}

bindSlickNavEvents();

let resizeTimeout;

window.addEventListener('resize', function() {
	clearTimeout(resizeTimeout);

	resizeTimeout = setTimeout(() => {
		initVideoSlides();
	}, 250);
});